import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../interfaces/api-response.model';
import {
  AppointmentHistoryResponse,
  HealthCheckPlanResponse,
  ModifyPersonalHeathCheckInfoRequest,
  ModifyPersonalHeathCheckInfoResponse,
  CancelAppointmentRequest,
  ModifyBusinessHeathCheckInfoRequest
} from '../interfaces/my-reservation.model';
import { API_ENDPOINTS } from '../constants/api.constants';

/**
 * 會員中心我的預約服務
 */
@Injectable({
  providedIn: 'root',
})
export class MyReservationService {
  http: HttpClient = inject(HttpClient);

  /**
   * 查詢預約紀錄及已完成健檢，依據功能別回傳不同資料供前端使用
   * @param idNo 身分證字號
   */
  getAppointmentHistory(
    idNo: string,
  ): Observable<ApiResponse<AppointmentHistoryResponse>> {
    const payload = { idNo };
    return this.http.post<ApiResponse<AppointmentHistoryResponse>>(
      API_ENDPOINTS.APPOINTMENT_HISTORY,
      payload
    );
  }

  /**
   * 取得預約資訊 (CB-007)
   * @param chartNo 病例號
   * @param idNo 身分證號
   */
  getHealthCheckPlan(
    chartNo: string,
    idNo: string
  ): Observable<ApiResponse<HealthCheckPlanResponse>> {
    const payload = { chartNo, idNo };
    return this.http.post<ApiResponse<HealthCheckPlanResponse>>(
      API_ENDPOINTS.HEALTH_CHECK_PLAN,
      payload
    );
  }

  /**
   * 取消預約資訊
   * @param request 取消預約請求
   */
  cancelAppointment(request: CancelAppointmentRequest): Observable<ApiResponse<null>> {
    return this.http.post<ApiResponse<null>>(
      API_ENDPOINTS.CANCEL_APPOINTMENT,
      request
    );
  }

  /**
   * 個人-修改預約資訊CB-019
   * 
   */
  modifyPersonalHeathCheckInfo(request: ModifyPersonalHeathCheckInfoRequest): Observable<ApiResponse<ModifyPersonalHeathCheckInfoResponse>> {
    return this.http.patch<ApiResponse<ModifyPersonalHeathCheckInfoResponse>>(
      API_ENDPOINTS.MODIFY_PERSONAL_HEALTH_CHECK_INFO,
      request
    );
  }

  /**
   * 企業-修改預約資訊CB-072
   * 
   */
  modifyBusinessHeathCheckInfo(request: ModifyBusinessHeathCheckInfoRequest): Observable<ApiResponse<ModifyPersonalHeathCheckInfoResponse>> {
    return this.http.patch<ApiResponse<ModifyPersonalHeathCheckInfoResponse>>(
      API_ENDPOINTS.MODIFY_BUSINESS_HEALTH_CHECK_INFO,
      request
    );
  }
}